/* eslint-disable camelcase */

import {FormDataBase} from "/src/types";

/*
  Register Multi-Step Form Conditions
*/

const MULTI_STEP_FORM_CONDITIONS: Record<string, any> = {
  /* Form name */
  "get-started-form-jira-fmh-367-step-1": {
    /* Post submission url that has dependency on other field(s) */
    // we can append existing form data to the url
    // to do this, we can use the {{field_name}} syntax
    "https://login.portal.flexport.com/signup?_ga=2.112403204.1801736153.1713199127-1277458271.1700597386&email={{email}}":
      {
        /* Condition field name and the expected value (in order to direct to the url) */
        Annual_Shipments_Signup: [
          "I don't know",
          "I'm not interested in freight",
          "Fewer than 5",
        ],
        Average_Daily_Orders: [
          "I don't know",
          "I'm not interested in fulfilment",
          "Fewer than 60",
        ],
      },
  },
};

/*
  Private method to return the conditions object for a particular form
*/
// eslint-disable-next-line no-underscore-dangle
/**
 *
 * @param {string} formName
 * @return {Record<string, any>}
 */
const _getMultiStepFormConditions = (formName: string): Record<string, any> => {
  if (!Object.keys(MULTI_STEP_FORM_CONDITIONS).includes(formName)) {
    return {};
  }
  return MULTI_STEP_FORM_CONDITIONS[formName];
};

/**
 *
 * @param {FormDataBase} data
 * @param {string} formName
 * @return {string}
 */
export const computeFormSubmitTargetURL = (
  data: FormDataBase,
  formName: string
): string | null => {
  const conditionsRaw = _getMultiStepFormConditions(formName);
  let url = null;

  if (!data || Object.keys(conditionsRaw).length === 0) {
    return url;
  }

  const conditionsMetUrls = Object.keys(conditionsRaw);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < conditionsMetUrls.length; i++) {
    const conditionsMetUrl = conditionsMetUrls[i];
    const conditions = conditionsRaw[conditionsMetUrl]; // Conditions that need to be met for specific url
    const conditionsFieldNames = Object.keys(conditions);
    let found = true;
    // eslint-disable-next-line no-plusplus
    for (let j = 0; j < conditionsFieldNames.length; j++) {
      const conditionFieldName = conditionsFieldNames[j];
      const inputValue = data[conditionFieldName as keyof typeof data];
      const expectedConditionValue = conditions[conditionFieldName];
      // Compare each condition's field expected value against user's input value
      if (
        (typeof expectedConditionValue === "string" &&
          inputValue !== expectedConditionValue) ||
        (Array.isArray(expectedConditionValue) &&
          !expectedConditionValue.includes(inputValue))
      ) {
        found = false;
        break;
      }
    }

    // Break out of loop once all conditions for one url have been met
    if (found) {
      url = conditionsMetUrl;
      break;
    }
  }

  return url;
};

/**
 *
 * @param {string} formName
 * @return {boolean}
 */
export const hasConditionalSteps = (formName: string): boolean => {
  return Object.keys(MULTI_STEP_FORM_CONDITIONS).includes(formName);
};
